/** @jsxImportSource @emotion/react */
//import { Link } from 'react-router-dom';
import { useMemo, useState, useEffect } from "react";
import { Button } from "react-bootstrap";

//components
import PageHeader from "../../components/atoms/PageHeader";
import "../../styles/pages/download.scss";
import LabelInput from "../../components/molecules/LabelInput";

import MultiSelect from "../../components/molecules/MultiSelect";
import MultiSelectTime from "../../components/molecules/MultiSelecttime";
import {
  PHONE_DAY_OPEN_DEFAULT,
  PHONE_DAY_OPEN_TEST,
  PHONE_DAY_OPEN_FINANCIAL_AGENCY,
  PHONE_DAY_OPEN_FAEP,
  PHONE_TIME_DEFAULT,
  PHONE_TIME_TEST,
  PHONE_TIME_FINANCIAL_AGENCY,
  PHONE_TIME_FAEP
} from "../../components/molecules/PhoneSetting";

import PolicyModal from "../../components/molecules/PolicyModal";
import {
  detailDiagnoseStorage,
  simpleDiagnoseStorage,
} from "../../utils/storage";
import { EstimateInsurance2, MultiSelectDay } from "../../openApi/api";
import DocumentDescription from "./components/DocumentDescription";
import { useContactDocument } from "../../query/useContactDocument";

const Download_document = () => {
  const baseCode = process.env.REACT_APP_CODE;
  
  const queryParameters = new URLSearchParams(window.location.search);
  const diagnosCode = queryParameters.get("diagnosCode") ?? undefined;
  const fromComparison = queryParameters.get("fromComparison");

  const simpleDiagnose = useMemo(() => simpleDiagnoseStorage.get(), []);
  const detailDiagnose = useMemo(() => detailDiagnoseStorage.get(), []);

  const estimateInsurances = useMemo(() => {
    if (simpleDiagnose.result.diagnos_code === diagnosCode) {
      return simpleDiagnose.result.recommended_insurance_items?.map((value) => {
        return {
          insurance_code: value.insurance_code,
          insurance_fee_codes: value.insurance_fee_codes,
        };
      }) as EstimateInsurance2[];
    } else {
      return detailDiagnose.result.recommended_insurance_items?.map((value) => {
        return {
          insurance_code: value.insurance_code,
          insurance_fee_codes: value.insurance_fee_codes,
        };
      }) as EstimateInsurance2[];
    }
  }, [simpleDiagnose, detailDiagnose, diagnosCode]);

  const [optionsDaySelect, setOptionsDaySelect] = useState<MultiSelectDay[]>([]);
  const [optionsTimeSelect, setOptionsTimeSelect] = useState<string[]>([]);
  
  useEffect(() => {
    if (baseCode === 'test'){
      setOptionsDaySelect(PHONE_DAY_OPEN_TEST);
      setOptionsTimeSelect(PHONE_TIME_TEST);
    } else if (baseCode === 'financial-agency'){
      setOptionsDaySelect(PHONE_DAY_OPEN_FINANCIAL_AGENCY);
      setOptionsTimeSelect(PHONE_TIME_FINANCIAL_AGENCY);
    } else if (baseCode === 'faep'){
      setOptionsDaySelect(PHONE_DAY_OPEN_FAEP);
      setOptionsTimeSelect(PHONE_TIME_FAEP);
    } else {
      setOptionsDaySelect(PHONE_DAY_OPEN_DEFAULT);
      setOptionsTimeSelect(PHONE_TIME_DEFAULT);
    }
  }, [baseCode, setOptionsDaySelect]);
  
  const [modal, setModal] = useState(false);

  const [name, setName] = useState<string>();
  const [nameKana, setNameKana] = useState<string>();
  const [tel, setTel] = useState<string>();
  const [candidateDayOfWeek, setCandidateDayOfWeek] = useState<string[]>();
  const [candidateTimeZone, setCandidateTimeZone] = useState<string[]>();
  const [email, setEmail] = useState<string>();

  const { mutate: postContactDocument } = useContactDocument();

  const clearUndefine = () => {
    if (name === undefined) setName("");
    if (nameKana === undefined) setNameKana("");
    if (tel === undefined) setTel("");
    if (candidateDayOfWeek === undefined) setCandidateDayOfWeek([]);
    if (candidateTimeZone === undefined) setCandidateTimeZone([]);
    if (email === undefined) setEmail("");
  };
  const onSubmit = () => {
    if (
      name === undefined ||
      name === "" ||
      nameKana === undefined ||
      nameKana === "" ||
      tel === undefined ||
      tel === "" ||
      candidateDayOfWeek === undefined ||
      candidateDayOfWeek.length === 0 ||
      candidateTimeZone === undefined ||
      candidateTimeZone.length === 0 ||
      email === undefined ||
      email === ""
    ) {
      clearUndefine();
      return;
    }

    postContactDocument({
      diagnos_code: diagnosCode,
      name,
      name_kana: nameKana,
      tel,
      candidate_day_of_week: candidateDayOfWeek,
      candidate_time_zone: candidateTimeZone,
      email,
      from_comparison: fromComparison === "true",
      estimate_insurances: estimateInsurances,
    });
  };

  return (
    <>
      <section className="download-fp-section">
        <PageHeader>資料請求</PageHeader>
        <DocumentDescription />
        <div className="downloadDocumentForm">
          <LabelInput
            label="名前"
            placeholder="苗字　名前"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
          />
          <LabelInput
            label="フリガナ"
            placeholder="フリ　ガナ"
            value={nameKana}
            onChange={(e) => setNameKana(e.target.value)}
            required
          />
          <LabelInput
            label="電話番号"
            placeholder="0000-00-0000"
            value={tel}
            onChange={(e) => setTel(e.target.value)}
            required
          />
          <MultiSelect
            label="電話がつながりやすい曜日"
            options={optionsDaySelect}
            value={candidateDayOfWeek}
            onChange={(data) => setCandidateDayOfWeek(data)}
            selectKey="dayOfWeek"
            required
          />
          <MultiSelectTime
            label="電話がつながりやすい時間帯"
            options={optionsTimeSelect}
            value={candidateTimeZone}
            onChange={(data) => setCandidateTimeZone(data)}
            selectKey="timeZone"
            required
          />
          <LabelInput
            label="メールアドレス"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />

          <span className="typographyAnswerBtnDescription typographyAlignCenter">
            <span
              style={{
                color: "#0d6efd",
                cursor: "pointer",
              }}
              onClick={() => setModal(true)}
            >
              利用規約
            </span>
            へ同意したものとみなされます
          </span>
          <Button
            color="primary"
            className="downloadDocumentSubmit"
            onClick={onSubmit}
          >
            送信する
          </Button>
        </div>
      </section>
      <PolicyModal visible={modal} onClose={() => setModal(false)} />
    </>
  );
};
export default Download_document;
